// react
import React from "react"
import { connect } from "react-redux"
import { browserHistory } from "react-router"
// app
import Profile from "containers/Profile"


class Me extends React.Component {
    componentWillMount () {
        if (this.props.isAdmin) 
            browserHistory.replace("/search")
    }

    render() {
        const { personid } = this.props
        
        return (
            <Profile params={{ personid }} />
        )
    }
}

function mapStateToProps(state) {
    return {
        isAdmin: state.user.get("admin") === 1,
        personid: state.user.get("personid")
    }
}

export default connect(mapStateToProps)(Me)


/** WEBPACK FOOTER **
 ** ./src/containers/Profile/Me/me.js
 **/